import { Injectable } from "@angular/core";

import { AppConstants } from "@mp/app.constants";
import { BaseService } from "@mp/common/base/base.service";

@Injectable({
    providedIn: "root"
})
export class StorageService extends BaseService {
    private storage = localStorage;

    constructor() {
        super();
        this.log.debug("Storage service initialized");
    }

    public getItem(key: string): string {
        return this.storage.getItem(key) as string;
    }

    public getObject<T>(key: string): T {
        let ret: T | null;
        const value = this.getItem(key);
        try {
            ret = JSON.parse(value) as T;
        } catch (err) {
            this.log.err("Error parsing json", key, value);
            ret = null;
        }

        return ret as T;
    }

    public setItem(key: string, value: string): void {
        this.storage.setItem(key, value);
    }

    public setObject<T>(key: string, value: T): void {
        try {
            const json = JSON.stringify(value);
            this.storage.setItem(key, json);
        } catch (err) {
            this.log.err("Error json conversion", key, value);
        }
    }

    public removeItem(key: string): void {
        this.storage.removeItem(key);
    }

    public clear(): void {
        const keysToRemove: Array<string> = [];
        for (let i = 0; i < this.storage.length; i++) {
            const key = this.storage.key(i);
            if (key && key.startsWith(AppConstants.STORAGE_PREFIX)) {
                keysToRemove.push(key);
            }
        }
        for (const key of keysToRemove) {
            this.storage.removeItem(key);
        }
    }
}
